import React, { Children } from "react";
import { twMerge } from "tailwind-merge";
import { Theme, useThemed } from "../hooks/useTheme";
import { Link } from "gatsby-plugin-react-i18next";

export const Button = (props: {
  to: string;
  anchor?: boolean;
  target?: string;
  label: string;
  className?: string;
  theme?: Theme;
  variant: "primary" | "secondary" | "clear" | "accent";
  icon?: JSX.Element;
}) => {
  const themed = useThemed(props.theme);

  const className = twMerge(
    `h-12 uppercase whitespace-nowrap flex-nowrap w-full md:w-auto m-auto flex items-center justify-center px-3 sm:px-7 py-3 font-semibold rounded-2xl md:py-3 text-sm md:text-md  min-w-[10rem] align-middle`,
    props.variant === "primary" &&
      "text-white bg-indigo-600 hover:bg-indigo-700 shadow",
    props.variant === "secondary" &&
      themed(
        {
          dark: "text-indigo-50 bg-indigo-900 hover:bg-indigo-800 border border-indigo-700",
        },
        "text-indigo-700 bg-indigo-100 hover:bg-indigo-200 border border-indigo-300 dark:text-indigo-50 dark:bg-indigo-900 dark:hover:bg-indigo-800 dark:border-indigo-700",
      ),
    props.variant === "clear" && "text-indigo-500 dark:text-indigo-400 hover:underline",
    props.variant === "accent" &&
      "text-white bg-astrorei-500 hover:bg-astrorei-600",
  );
  const child = (
    <>
      {props.label}
      {props.icon &&
        React.cloneElement(props.icon, {
          className: "w-6 h-6 ml-2 sm:ml-4 shrink-0",
        })}
    </>
  );

  return (
    <div className={twMerge("w-full md:w-fit text-center", props.className)}>
      {props.to.startsWith("http") || props.anchor ? (
        <a href={props.to} target={props.target} className={className}>
          {child}
        </a>
      ) : (
        <Link to={props.to} target={props.target} className={className}>
          {child}
        </Link>
      )}
    </div>
  );
};
